module.exports = __webpack_public_path__ + "static/media/sign_say_instructions.fe133497.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign_say_instructions.png
// module id = 836
// module chunks = 0